const $ea1a02edf608271f$var$chances = [
    [
        0,
        1,
        2
    ],
    [
        3,
        4,
        5
    ],
    [
        6,
        7,
        8
    ],
    [
        0,
        3,
        6
    ],
    [
        1,
        4,
        7
    ],
    [
        2,
        5,
        8
    ],
    [
        0,
        4,
        8
    ],
    [
        2,
        4,
        6
    ]
];
var $ea1a02edf608271f$export$2e2bcd8739ae039 = $ea1a02edf608271f$var$chances;


console.log((0, $ea1a02edf608271f$export$2e2bcd8739ae039));
// const fruits = ["apple", "kiwi", "banana", "mango", "cheeku"];
// const a = fruits.unshift();
// console.log(a);
// function getbetween(input) {
//     return input.slice(1, input.lenght -1);
// }
// const x = getbetween(fruits);
// console.log(x);
// console.log(getbetween([1, 2, 3, 4, 5]));
// const fruits = ["apple", "kiwi", "banana", "mango", "cheeku"];
// const z = fruits.join("-")
// console.log(z);
// function table(num) {
//     for (let i = 1; i <= 10; i++){
//         console.log(`${num}x${i}=${num * i}`);
//     }
// }
// table(3);
// const num = [1, 2, 3, 4,]
// for (let j = 0; j < nums.length; j++) {
//     nums[j] = num[j]*2
// }
// console.log(num)
// const nums = [1, 20,32,443]
// nums.forEach(function (v, idk) {
//     nums[idk] = v * 2;
// });
// console.log(nums);
// const nums = [2,4,6,8]
// numsEven = [flase,true,flase,true]
// const evenNums = nums.map (function (value) {
//     if (value % 2 == 0) {
//         return "even";
//     } else {
//         return "odd";
//     }
//     }
// });
// console.log(evenNums);
// const evenNums = [];
// nums.forEach()
const $650607d6ef817a02$var$headingEl = document.querySelector(".heading");
const $650607d6ef817a02$var$currentPlayerEl = document.querySelector(".current-player");
const $650607d6ef817a02$var$boxes = document.querySelectorAll(".box");
const $650607d6ef817a02$var$resetBtn = document.querySelector(".btn-reset");
console.log($650607d6ef817a02$var$boxes);
// game variable
const $650607d6ef817a02$var$players = [
    "0",
    "x"
];
let $650607d6ef817a02$var$currPlayer = "0";
let $650607d6ef817a02$var$virtualGrid;
function $650607d6ef817a02$var$getPlayer() {
    const rn = Math.floor(Math.random() * 2);
    return $650607d6ef817a02$var$players[rn];
}
function $650607d6ef817a02$var$swapPlayer() {
    const newPlayer = $650607d6ef817a02$var$currPlayer === "0" ? "x" : "0";
    $650607d6ef817a02$var$currPlayer = newPlayer;
    $650607d6ef817a02$var$currentPlayerEl.textContent = newPlayer;
}
function $650607d6ef817a02$var$startGame() {
    $650607d6ef817a02$var$currPlayer = $650607d6ef817a02$var$getPlayer();
    $650607d6ef817a02$var$virtualGrid = new Array(9).fill("");
    $650607d6ef817a02$var$currentPlayerEl.textContent = $650607d6ef817a02$var$currPlayer;
}
function $650607d6ef817a02$var$checkIfWon() {}
function $650607d6ef817a02$var$handleBoxClick(input) {
    if ($650607d6ef817a02$var$virtualGrid[input] === "") {
        console.log(input);
        $650607d6ef817a02$var$boxes[input].textContent = $650607d6ef817a02$var$currPlayer;
        $650607d6ef817a02$var$boxes[input].style.cursor = "auto";
        $650607d6ef817a02$var$virtualGrid[input] = $650607d6ef817a02$var$currPlayer;
        console.log($650607d6ef817a02$var$virtualGrid);
        $650607d6ef817a02$var$checkIfWon();
        $650607d6ef817a02$var$swapPlayer();
    }
}
console.log($650607d6ef817a02$var$boxes);
$650607d6ef817a02$var$boxes.forEach(function(box, index) {
    box.addEventListener("click", function() {
        $650607d6ef817a02$var$handleBoxClick(index);
    });
});
function $650607d6ef817a02$var$handleReset() {
    alert("hey");
}
$650607d6ef817a02$var$resetBtn.addEventListener("click", $650607d6ef817a02$var$handleReset);
document.addEventListener("DOMContentLoaded", $650607d6ef817a02$var$startGame);


//# sourceMappingURL=index.64f3c8dc.js.map
